module.exports = __webpack_public_path__ + "media/images/bnr_recommend_email_80off-6f251862a0567f74bdc52363a5774eea.jpg";